import { z } from "zod";

export const email = z.email({ error: "Invalid email address" });
